"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoWrap = exports.RightColumn = exports.LeftColumn = exports.Column = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.Wrap = (0, app_1.styled)(ui_1.Grid) `
  --content-max-width: 1440px;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;

  @media ${app_1.notDesktop} {
    max-height: none;
    height: auto;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;
exports.Column = (0, app_1.styled)(ui_1.GridItem) `
  padding: 4rem;
  padding-top: 0;
  align-items: flex-start;
  overflow: auto;

  > div {
    max-width: calc(var(--content-max-width) / 2);
    width: 100%;
  }

  @media ${app_1.notDesktop} {
    padding: 1rem;
  }
`;
exports.LeftColumn = (0, app_1.styled)(exports.Column) `
  background: white;
`;
exports.RightColumn = (0, app_1.styled)(exports.Column) `
  background: #eef1f5;
  padding-top: calc(12.625rem - 3.1325rem);
`;
exports.LogoWrap = app_1.styled.div `
  height: 12.625rem;
  ${(theme) => theme.flexCenter}
`;
